export type IdentityVerificationPartner = "clear" | "persona";

type IdentityVerificationPartnerConfig = {
  partner: IdentityVerificationPartner;
  name: string;
  displayName: string;
  translationKey: IdentityVerificationPartner;
  learnMoreHref?: string;
  // Params the provider appends to our completion redirect; stripped so correlation ids don't linger in history or Referer.
  callbackParams: string[];
};

export const IDENTITY_VERIFICATION_LEARN_MORE_HREF =
  "https://support.greenhouse.io/hc/en-us/articles/40497797083419";

export const PARTNER_CONFIG: Record<
  IdentityVerificationPartner,
  IdentityVerificationPartnerConfig
> = {
  clear: {
    partner: "clear",
    name: "CLEAR",
    displayName: "CLEAR®",
    translationKey: "clear",
    learnMoreHref: IDENTITY_VERIFICATION_LEARN_MORE_HREF,
    callbackParams: [],
  },
  persona: {
    partner: "persona",
    name: "Persona",
    displayName: "Persona",
    translationKey: "persona",
    // `subject` echoes our reference id (task id + user external id); `status` is the inquiry outcome.
    callbackParams: ["subject", "status", "inquiry-id", "reference-id", "reference_id"],
  },
};

export const IDENTITY_VERIFICATION_CALLBACK_PARAMS = Object.values(PARTNER_CONFIG).flatMap(
  (config) => config.callbackParams,
);

export const isIdentityVerificationPartner = (
  partner?: string | null,
): partner is IdentityVerificationPartner => partner === "clear" || partner === "persona";

export const identityVerificationPartner = (
  partner?: string | null,
): IdentityVerificationPartner => {
  if (isIdentityVerificationPartner(partner)) return partner;

  throw new Error(`Unsupported identity verification partner: ${partner || "missing"}`);
};

export const identityVerificationPartnerConfig = (
  partner?: string | null,
): IdentityVerificationPartnerConfig => {
  const normalizedPartner = identityVerificationPartner(partner);

  return PARTNER_CONFIG[normalizedPartner];
};
